var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-switch',{attrs:{"hide-details":""},on:{"change":_vm.handleToggle},model:{value:(_vm.toggleValue),callback:function ($$v) {_vm.toggleValue=$$v},expression:"toggleValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }